import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import debounce from 'lodash/debounce';
import { motion, AnimatePresence } from 'motion/react';
import { Icon } from '@grandvisionhq/icons';

const posedIcon = {
    buttonWithDropdownIdle: {
        rotate: 0
    },
    buttonWithDropdownIsActive: {
        rotate: 180
    }
};
const posedContent = {
    enter: {
        opacity: 1,
        y: 0,
        overflow: 'hidden',
        transitionEnd: {
            overflow: ''
        }
    },
    exit: {
        opacity: 0,
        y: -25,
        overflow: 'hidden',
        transition: {
            duration: 0
        }
    }
};
class ButtonWithDropdown extends React.Component {
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.setOffset();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.isActive !== this.props.isActive || prevState.isActive !== this.state.isActive) {
            this.setOffset();
        }
    }
    render() {
        const _props = this.props, { label , children , isFullWidth , isDisabled , className , id , 'data-t': dataT  } = _props, rest = swcHelpers.objectWithoutProperties(_props, [
            "label",
            "children",
            "isFullWidth",
            "isDisabled",
            "className",
            "id",
            'data-t'
        ]);
        const ariaProps = {
            'aria-label': rest['aria-label'],
            'aria-labelledby': rest['aria-labelledby'],
            'aria-describedby': rest['aria-describedby'],
            'aria-required': rest['aria-required'],
            'aria-invalid': rest['aria-invalid']
        };
        const buttonInnerRole = ariaProps['aria-label'] || ariaProps['aria-labelledby'] ? 'presentation' : '';
        const { offset  } = this.state;
        const isControlled = typeof this.props.isActive === 'boolean';
        const isActive = isControlled ? this.props.isActive : this.state.isActive;
        const dropdownClassnames = classnames('button-with-dropdown', {
            _is_full_width: isFullWidth
        });
        const buttonClassnames = classnames('button-with-dropdown__button', className, {
            _is_active: isActive,
            _is_full_width: !!isFullWidth
        });
        const contentClassnames = classnames('button-with-dropdown__content', {
            _is_active: isActive,
            _is_full_width: !!isFullWidth,
            _is_disabled: isDisabled
        });
        return /*#__PURE__*/ React.createElement(motion.div, {
            className: dropdownClassnames,
            animate: isActive ? 'buttonWithDropdownIsActive' : 'buttonWithDropdownIdle'
        }, /*#__PURE__*/ React.createElement("button", swcHelpers.extends({
            className: buttonClassnames,
            id: id,
            onClick: this.handleClick,
            type: "button",
            "aria-haspopup": "true",
            "aria-expanded": isActive,
            "data-t": dataT
        }, ariaProps), /*#__PURE__*/ React.createElement("span", {
            className: "button-with-dropdown__button-inner",
            role: buttonInnerRole
        }, /*#__PURE__*/ React.createElement("span", {
            className: "button-with-dropdown__label"
        }, label), !isDisabled && /*#__PURE__*/ React.createElement(motion.span, {
            className: "button-with-dropdown__icon",
            variants: posedIcon
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "chevron-down"
        })))), /*#__PURE__*/ React.createElement("div", {
            className: "button-with-dropdown__content-container",
            style: {
                left: offset
            }
        }, /*#__PURE__*/ React.createElement(AnimatePresence, null, isActive && /*#__PURE__*/ React.createElement(motion.span, {
            initial: "exit",
            animate: "enter",
            exit: "exit",
            variants: posedContent,
            key: "_",
            className: contentClassnames,
            ref: this.contentRef,
            "data-t": "button-with-dropdown-active-container"
        }, children))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            offset: 0,
            isActive: typeof this.props.isActive === 'boolean' ? this.props.isActive : this.props.initialActive || false
        };
        this.contentRef = /*#__PURE__*/ React.createRef();
        this.handleResize = debounce(()=>this.setOffset()
        , 60);
        this.setOffset = ()=>{
            if (this.contentRef.current && !this.props.isFullWidth) {
                const { innerWidth  } = window;
                const { right  } = this.contentRef.current.getBoundingClientRect();
                const scrollBarWidth = 25 // IE needs this
                ;
                const offset = Math.min(innerWidth - (right - this.state.offset + scrollBarWidth), 0);
                if (offset !== this.state.offset) {
                    this.setState({
                        offset
                    });
                }
            }
        };
        this.handleClick = ()=>{
            const isControlled = typeof this.props.isActive === 'boolean';
            const isActive = !(isControlled ? this.props.isActive : this.state.isActive);
            !isControlled && this.setState(()=>({
                    isActive
                })
            );
            this.props.onClick && this.props.onClick(isActive);
        };
    }
}

export { ButtonWithDropdown as default };
//# sourceMappingURL=ButtonWithDropdown.js.map
